/* eslint-disable @typescript-eslint/no-namespace */
import { Country } from '../country.js';
import { LegacySerialNumberStrategy } from './legacy-serial-number-strategy.js';

export enum SerialNumberStrategy {
  AssignByTemplate = 'AssignByTemplate',
  AssignByPrice = 'AssignByPrice',
}

export namespace SerialNumberStrategyUtils {
  export function fromLegacy(legacy: LegacySerialNumberStrategy): SerialNumberStrategy {
    switch(legacy) {
      case LegacySerialNumberStrategy.AssignByTicketType:
        return SerialNumberStrategy.AssignByTemplate;
      case LegacySerialNumberStrategy.AssignByTicketPrice:
        return SerialNumberStrategy.AssignByPrice;
    }
  }
}

export function getSerialNumberStrategyOfCountry(country: Country): SerialNumberStrategy {
  switch(country) {
    case Country.Austria:
      return SerialNumberStrategy.AssignByTemplate;
    case Country.Hungary:
      return SerialNumberStrategy.AssignByTemplate;
    case Country.Romania:
      return SerialNumberStrategy.AssignByPrice;
    case Country.Slovakia:
      return SerialNumberStrategy.AssignByTemplate;
    case Country.Slovenia:
      return SerialNumberStrategy.AssignByTemplate;
  }
}
